import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Review as ReviewInterface } from "../../models";
import { Carousel } from "./components/carousel/Carousel";

type Props = {
  title: string;
  reviews: ReviewInterface[];
};

export const Reviews: FC<Props> = ({ title, reviews }) => (
  <div
    className={classNames(
      "mt-20 px-5 text-center text-primary-content",
      "lg:mx-auto lg:mt-25 lg:w-4/6 lg:px-0",
      "xl:mt-40 xl:max-w-[1076px]",
    )}
  >
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <h3
        className={classNames(
          "mb-5 text-regular",
          "lg:mb-10 lg:text-medium",
          "xl:mb-15 xl:text-large",
        )}
      >
        {title}
      </h3>
      <Carousel reviews={reviews} />
    </Fade>
  </div>
);
